import fetch from '@/utils/fetch'

/**
 *获取地块头部信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getLandHead(landId) {
    return fetch.request({
        url: '/land/head/' + landId,
        method: 'get'
    })
}
